const table = {
  columnList: 'Lista de colunas',
  noResults: 'Não há resultados',
  noResultsSubHeader: 'Não conseguimos encontrar nenhum item que corresponda à sua pesquisa',
};

export default table;
